(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'memberAdminResolver', 'scoreHistoryResolver', 'handicapCalculationResolver', 'handicapCardResolver', 'memberSettingsResolver', 'membershipResolver', 'memberRolesResolver', 'ignMembershipListResolver', 'memberIntegrationResolver', 'memberPostingResolver', 'modifyHandicapResolver', 'mergeMemberResolver', 'memberCourseListResolver', 'handicapHistoryResolver', 'adjustScoresResolver', 'deletedScoresResolver', 'memberAttributesResolver'];
    function configRoutes($stateProvider, memberAdminResolver, scoreHistoryResolver, handicapCalculationResolver, handicapCardResolver, memberSettingsResolver, membershipResolver, memberRolesResolver, ignMembershipListResolver, memberIntegrationResolver, memberPostingResolver, modifyHandicapResolver, mergeMemberResolver, memberCourseListResolver, handicapHistoryResolver, adjustScoresResolver, deletedScoresResolver, memberAttributesResolver) {
        $stateProvider
            // Member Admin
            .state('member-admin', {
                url: '/members/:individualId',
                component: 'sc3MemberAdmin',
                resolve: memberAdminResolver,
                params: {
                    individualId: { type: 'int' }
                },
                data: {
                    requireAdmin: true
                },
                redirectTo: 'member-admin.score-history'
            })

            // Score History
            .state('member-admin.score-history', {
                url: '',
                component: 'sc3ScoreHistory',
                resolve: scoreHistoryResolver
            })

            // Deleted Scores
            .state('member-admin.deleted-scores', {
                url: '',
                component: 'sc3DeletedScores',
                resolve: deletedScoresResolver
            })

            // Handicap Calculation
            .state('member-admin.handicap-calculation', {
                url: '/handicap-calculation',
                component: 'sc3HandicapCalculation',
                resolve: handicapCalculationResolver
            })

            // Handicap Card
            .state('member-admin.handicap-card', {
                url: '/handicap-card',
                component: 'sc3HandicapCard',
                resolve: handicapCardResolver
            })

            // Settings
            .state('member-admin.settings', {
                url: '/settings',
                component: 'sc3MemberSettings',
                resolve: memberSettingsResolver
            })

            // Membership
            .state('member-admin.membership', {
                url: '/membership',
                component: 'sc3Membership',
                resolve: membershipResolver
            })
  
            // Roles
            .state('member-admin.roles', {
                url: '/roles',
                component: 'sc3MemberRoles',
                resolve: memberRolesResolver
            })

            // IGN
            .state('member-admin.ign-membership', {
                url: '/ign-membership',
                component: 'sc3IgnMembershipList',
                resolve: ignMembershipListResolver
            })

            // Integration
            .state('member-admin.integration', {
                url: '/integration',
                component: 'sc3MemberIntegration',
                resolve: memberIntegrationResolver
            })

            // Attributes
            .state('member-admin.attributes', {
                url: '/attributes',
                component: 'sc3MemberAttributes',
                resolve: memberAttributesResolver
            })

            // Score Posting
            .state('member-admin.post-score', {
                url: '/post-score/:scoreId',
                component: 'sc3MemberPosting',
                resolve: memberPostingResolver,
                params: {
                    scoreId: null
                }
            })

            // Modify Handicap
            .state('member-admin.modify-handicap', {
                url: '/modify-handicap',
                component: 'sc3ModifyHandicap',
                resolve: modifyHandicapResolver
            })          

            // Adjust Scores
            .state('member-admin.adjust-scores', {
                url: '/adjust-scores',
                component: 'sc3AdjustScores',
                resolve: adjustScoresResolver
            })         

            // Merge Member
            .state('member-admin.merge-member', {
                url: '/merge-member',
                component: 'sc3MergeMember',
                resolve: mergeMemberResolver
            })

            // Course List
            .state('member-admin.course-list', {
                url: '/course-list',
                component: 'sc3MemberCourseList',
                resolve: memberCourseListResolver
            })

            // Handicap History
            .state('member-admin.handicap-history', {
                url: '/handicap-history',
                component: 'sc3HandicapHistory',
                resolve: handicapHistoryResolver
            })         

    }
})();